import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SingleService from '../SingleService/SingleService';
import './Services.css';
const Services = () => {
    const [services, setServices] = useState([]);
    useEffect(() => {
      fetch('services.json')
      .then(res => res.json())
      .then(data => setServices(data));
    }, [])
    
    return (
        <div className='training my-5'>
            <Container>
                    <Col>
                        <h2 className='title my-5'>TRAINING :- </h2>
                    </Col>
                <Row lg={3} md={2} xs={1} className='g-4'>
                    {
                        services.map(service => <SingleService key={service.id} service = {service}/>)
                    }
                </Row>
            </Container>
        </div>
    );
};

export default Services;


